export const stringifyList = (value) => {
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "string") return value;
  return "";
};

export const describeAffiliation = (row) => {
  if (!row) return "";
  const { industry_categories, organization, type, role, country } = row;
  if (Array.isArray(industry_categories) && industry_categories.length > 0) {
    return industry_categories.join(", ");
  }
  if (
    typeof industry_categories === "string" &&
    industry_categories.trim().length > 0
  ) {
    return industry_categories.trim();
  }
  if (organization && organization.trim()) return organization.trim();
  if (type && String(type).trim()) return String(type).trim();
  if (country && String(country).trim()) return String(country).trim();
  if (role && String(role).trim()) return String(role).trim();
  return "";
};

export const normalizeSelectedThemes = (value) => {
  if (!value) return [];

  const extractName = (entry) => {
    if (!entry) return "";
    if (typeof entry === "string") return entry;
    if (Array.isArray(entry)) return null;
    if (typeof entry === "object") {
      if (entry.selected === false) return "";
      if (typeof entry.selected === "string") {
        return entry.selected;
      }
      if (Array.isArray(entry.selected)) {
        return normalizeSelectedThemes(entry.selected);
      }
      if (Array.isArray(entry.items)) {
        return normalizeSelectedThemes(entry.items);
      }
      if (Array.isArray(entry.themes)) {
        return normalizeSelectedThemes(entry.themes);
      }
      const name =
        entry.name ??
        entry.label ??
        entry.title ??
        entry.theme ??
        entry.value ??
        entry.key ??
        entry.slug ??
        entry.id ??
        entry.topic ??
        null;
      return typeof name === "string" ? name : "";
    }
    return "";
  };

  const collected = [];
  const pushEntry = (entry) => {
    if (entry == null) return;
    if (Array.isArray(entry)) {
      entry.forEach(pushEntry);
      return;
    }
    if (typeof entry === "string") {
      const pieces = entry
        .split(/[;,|]/)
        .map((s) => s.trim())
        .filter(Boolean);
      if (pieces.length === 0) return;
      pieces.forEach((piece) => collected.push(piece));
      return;
    }
    const extracted = extractName(entry);
    if (Array.isArray(extracted)) {
      extracted.forEach(pushEntry);
      return;
    }
    if (typeof extracted === "string") {
      const trimmed = extracted.trim();
      if (trimmed) collected.push(trimmed);
    }
  };

  pushEntry(value);
  return Array.from(new Set(collected));
};

export const sanitizeThemeId = (value) => {
  if (value == null) return null;
  const str = String(value).trim();
  if (!str) return null;
  return /^\d+$/.test(str) ? str : null;
};

export const parseThemeIds = (value) => {
  const ids = new Set();
  const addId = (candidate) => {
    const sanitized = sanitizeThemeId(candidate);
    if (sanitized) ids.add(sanitized);
  };
  const visit = (entry) => {
    if (entry == null) return;
    if (Array.isArray(entry)) {
      entry.forEach(visit);
      return;
    }
    if (typeof entry === "object") {
      const candidates = [
        entry.topic_id,
        entry.theme_id,
        entry.themeId,
        entry.topicId,
        entry.id,
        entry.value,
        entry.key,
        entry.slug,
      ];
      candidates.forEach(addId);
      if (entry.selected !== undefined) visit(entry.selected);
      if (Array.isArray(entry.items)) visit(entry.items);
      if (Array.isArray(entry.themes)) visit(entry.themes);
      return;
    }
    if (typeof entry === "string") {
      const trimmed = entry.trim();
      if (!trimmed) return;
      const looksJson =
        (trimmed.startsWith("[") && trimmed.endsWith("]")) ||
        (trimmed.startsWith("{") && trimmed.endsWith("}"));
      if (looksJson) {
        try {
          const parsed = JSON.parse(trimmed);
          visit(parsed);
          return;
        } catch (_) {
          // fall through
        }
      }
      trimmed
        .split(/[,;|]/)
        .map((piece) => piece.trim())
        .filter(Boolean)
        .forEach((piece) => addId(piece));
      return;
    }
    if (typeof entry === "number") {
      addId(entry);
    }
  };

  visit(value);
  return Array.from(ids);
};
